import React from "react";
import AvatarInput from "../../../components/AvatarInput";
import { TranslationObject } from "../../../models/translationModal";
import { Link } from "react-router-dom";
import {getCurrentLanguage, isSpecialistUrl} from "../../../store/directories/selectors";
import {endpoints as endpointsDirectories} from "../../../store/directories/directories.api";

interface ProfileHeaderProps {
    name: string;
    familyName: string;
    visibleChangeAvatar?: boolean;
    userSpecialistRole?: { role: string; translate: string };
    entities?: TranslationObject;
    setPhoto: (value: string | null) => void;
    photo?: string | null;
    setAvaterIsDeleted: (value: boolean) => void;
    avaterIsDeleted: boolean
    bonusCount: number
}

export const ProfileHeader: React.FC<ProfileHeaderProps> = ({
    name = "",
    familyName = "",
    visibleChangeAvatar = true,
    userSpecialistRole,
    entities,
    setPhoto,
    photo,
    setAvaterIsDeleted,
    avaterIsDeleted,
    bonusCount
}) => {
    const currentLanguage = getCurrentLanguage();

    const isSpecialist = isSpecialistUrl();

    const linkToOrders = `/${currentLanguage}/${isSpecialist ? 'specialist' : 'customer'}/lk/orders`;

    const { data: directories } =
        endpointsDirectories.getDirectories.useQuery();

    const linkBonusProgram = directories?.custom_pages?.find(
        (elem) => elem.code === "bonuses_and_partners"
    )?.path;

    const bonusDesc = isSpecialist ? entities?.bonus_desc_specialist?.value : entities?.bonus_desc_customer?.value

    return (
        <>
            <div className="specialist-profile__header grey-card specialist-profile__header-row">
                <div className="specialist-profile__user-info grey-card">
                    <div className="specialist-profile__avatar avatar-block">
                        <div className="avatar avatar--md">
                            <AvatarInput
                                setPhoto={setPhoto}
                                photo={photo}
                                userType={"specialist"}
                                visibleChangeAvatar={visibleChangeAvatar}
                                entities={entities}
                                setAvaterIsDeleted={setAvaterIsDeleted}
                                avaterIsDeleted={avaterIsDeleted}
                            />
                        </div>
                    </div>
                    <div className="specialist-profile__name">
                        <h2 className="title title--h2">{`${name} ${familyName}`}</h2>
                        <p className="text">{userSpecialistRole?.translate}</p>
                    </div>
                    {bonusCount !== undefined && (
                        <div className="bonus-balance">
                            <p className="bonus-balance__heading">
                                {entities?.profile_bonuses?.value}{" "}
                                {bonusCount || 0}{" "}
                                {entities?.profile_bonuses_points?.value}
                            </p>
                            <p className={"bonus-balance__description"}>{bonusDesc}</p>
                            <Link
                                className="modal-review-pro__link"
                                to={`/${currentLanguage}/${linkBonusProgram}`}
                            >
                                {entities?.order_create_review_bonus_program?.value}
                            </Link>
                        </div>
                    )}
                </div>
                <Link className="order-information__buttons" to={linkToOrders}>
                    <button
                        className="btn order-information__button"
                        type="button"
                    >
                        {entities?.orders_link_value?.value || ""}
                    </button>
                </Link>
            </div>
        </>
    );
};
